import { Route } from 'react-router'

import UpgradePlan from '../UpgradePlan'

const PrivateRoute = ({ authorized, component: Component, objectKey, ...otherProps }) => {

  return (
    <Route {...otherProps} render={(props) =>
      authorized ? <Component {...props} key={objectKey ? otherProps.computedMatch.params[objectKey] : undefined} /> : <UpgradePlan />
    }/>
  )
}

export default PrivateRoute
